import { render, staticRenderFns } from "./PickingView.vue?vue&type=template&id=aafb2330"
import script from "./PickingView.vue?vue&type=script&lang=js"
export * from "./PickingView.vue?vue&type=script&lang=js"
import style0 from "./PickingView.vue?vue&type=style&index=0&id=aafb2330&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports